module.exports = __webpack_public_path__ + "img/manajemen_kepegawaian_pengajuan_diterima.d78b59a4.svg";